// Shared constants & helpers (statuses are now per-company; these are fallback defaults)
export const ROLES = {
  DIRECTOR: "director",
  HR: "hr",
  MANAGER: "manager",
  EMPLOYEE: "employee",
};

export const ROLE_LABELS = {
  director: "Директор",
  hr: "Отдел кадров",
  manager: "Начальник",
  employee: "Сотрудник",
};

export const DEFAULT_STATUSES = [
  { key: "work", label: "Явка", short: "Я", color: "#198754", paid_factor: 1.0 },
  { key: "absent", label: "Прогул", short: "ПР", color: "#dc3545", paid_factor: 0.0 },
  { key: "sick", label: "Больничный", short: "Б", color: "#ffc107", paid_factor: 0.0 },
  { key: "vacation", label: "Отпуск", short: "О", color: "#0dcaf0", paid_factor: 1.0 },
  { key: "business_trip", label: "Командировка", short: "К", color: "#6f42c1", paid_factor: 1.0 },
  { key: "halfday", label: "Полдня", short: "1/2", color: "#20c997", paid_factor: 0.5 },
];

export function statusesAsMap(statuses) {
  const m = {};
  (statuses || DEFAULT_STATUSES).forEach(s => { m[s.key] = s; });
  return m;
}

export function statusesAsList(company) {
  return (company?.statuses && company.statuses.length > 0) ? company.statuses : DEFAULT_STATUSES;
}

export function entryKey(uid, day) {
  return `${uid}_${String(day).padStart(2, "0")}`;
}

export function countWorkDays(daysMap) {
  return Object.values(daysMap || {}).filter(v => v === "work" || v === "short").length;
}
